export default __webpack_public_path__ + "static/media/btn-spotify.910489e2.png";